import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { action, select } from 'satcheljs/lib/legacy';
import { getMailboxJunkEmailConfiguration, saveMailboxJunkEmailConfiguration, } from 'owa-junkmail-configuration';
import { isEmailAddress } from 'owa-mail-option-common';
export default select({
    mailboxJunkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
    optionState: function () { return store; },
})(action('saveSafeMailingListsOption')(function saveSafeMailingListsOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, mailboxJunkEmailConfiguration, optionState, safeRecipients, safeDomains, safeRecipientsAndDomains;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = state, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration, optionState = _a.optionState;
                    safeRecipients = getFallbackValueIfNull(optionState.safeMailingLists, mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains.filter(function (item) {
                        return isEmailAddress(item);
                    }));
                    safeDomains = mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains.filter(function (item) { return !isEmailAddress(item); });
                    safeRecipientsAndDomains = safeRecipients.concat(safeDomains);
                    mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains = safeRecipientsAndDomains;
                    return [4 /*yield*/, saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSafeMailingListsOption.js.map